export default {
	'fiscal-year': 'año fiscal',
	'change-active-fiscal-year': 'Cambiar el año fiscal activo',
	'confirm-changing-active-fiscal-year': '¿Estás seguro de que quieres cambiar el año fiscal activo?',
	'confirm-delete-fiscal-year': '¿Estás seguro de que quieres eliminar el año fiscal?'
}